import { Suspense, useEffect } from 'react'
import SidebarV2 from '../../components/SidebarV2/SidebarV2'
import routeConfig from '../../configs/route.config'
import menuPrivilegeStore from '../../stores/menu-privilege.store'
import teamStore from '../../stores/team.store'
import userService from '../../services/user.service'
import userStore from '../../stores/user.store'
import { useMutation } from 'react-query'
import { useDispatch } from 'react-redux'
import { Header } from '../../components'
import { getTeamDetail, menuPrivilageSlice } from '../../redux'
import {
  Navigate,
  Outlet,
  useLocation,
} from 'react-router-dom'
import {
  Center,
  Flex,
  Spinner,
} from '@chakra-ui/react'

const MainApp = () => {
  const { fetchPrivilege } = menuPrivilegeStore()
  const { fetchTeam } = teamStore()
  const { setUser } = userStore()
  const location = useLocation()
  const dispatch = useDispatch<any>()

  const token = localStorage.getItem('access_token')
  const team = localStorage.getItem('current_team')
  const pageWithoutSidebar = [routeConfig.teams, routeConfig.invitations]
  const hideSidebar = pageWithoutSidebar.includes(location.pathname)

  const updateFcmMutation = useMutation(userService.updateFcm, {
    onSuccess: (resp) => {
      setUser(resp?.data)
    },
    onError: (error) => {
      console.log({ error })
      localStorage.clear()
    }
  })

  useEffect(() => {
    if (!token) return
    if (!team) return
    dispatch(menuPrivilageSlice.getMenuPrivilageAction())
    dispatch(getTeamDetail())
    fetchTeam()
    fetchPrivilege()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, team])

  if (!token || updateFcmMutation.isError) return <Navigate to={routeConfig.login} />

  if (!team && location.pathname !== routeConfig.teams) return <Navigate to={routeConfig.teams} />

  return (
    <Flex direction='column' width='100%'>
      <Header />
      <Flex
        height='calc(100vh - var(--headerHeight))'
        marginTop='var(--headerHeight)'
        width='100%'
      >
        {hideSidebar
          ? null
          : <SidebarV2 />
        }
        <Flex
          padding={{ base: '16px 8px', md: '16px 24px' }}
          height='calc(100vh - var(--headerHeight))'
          overflowY='auto'
          flex='1'
          backgroundColor='surface'
          id='app-main-content-wrapper'
        >
          <Suspense
            fallback={
              <Center width='100%'>
                <Spinner />
              </Center>
            }
          >
            <Outlet />
          </Suspense>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default MainApp